export const style = {
  IconThumbDown: {
    viewBox: '0 0 19 19',
  },
  Icon: {
    viewBox: '0 0 20 20',
    sx: {
      '& svg': {
        height: 20,
        width: 20,
      },
    },
  },
  Card: {
    sx: {
      width: 320,
      height: 150,
    },
  },
  Box: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      gap: 3,
      '& .MuiCardContent-root': {
        paddingBottom: '16px',
      },
    },
  },
} as const;
